import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import LinearProgress from "@material-ui/core/LinearProgress";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import getParamsFromString from "../../Utils/getParamsFromString";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useSelector} from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(() => ({
    linearProgressRoot: {
        height: 10,
        borderRadius: 3
    }
}));

const ProgressComponent = (props) => {
    const {component: {properties: {value, type}, styles}, screenName, actionsContext} = props;
    const {globalValues} = useSelector(state => state.jsonScreen);
    const classes = useStyles();
    const [progressValue, setProgressValue] = useState(0);
    const [progressStyles, setProgressStyles] = useState({});
    useEffect(() => {
        const findValue = getParamsFromString(value, {...globalValues, ...actionsContext}, screenName);
        setProgressValue(findValue)
    }, [JSON.stringify(globalValues), JSON.stringify(actionsContext)]);

    useEffect(() => {
        if (styles && styles.length) {
            setProgressStyles(styles[0])
        }
    }, [styles]);

    if (type === 'circle') {

        const size = 185;

        function parse(v) {
            return [v, v / 2]
        }

        const [sizeValue, sizeUnit] = parse(size);

        const scaledValue = progressValue / 2;
        return (
            <Box
                style={{
                    position: "relative",
                    display: "inline-flex",
                    width: sizeValue,
                    height: sizeUnit,
                    overflow: "hidden",
                }}>
                <Box
                    style={{
                        position: "absolute",
                        display: "inline-flex",
                        top: 0,
                        left: 0,
                        transform: "rotate(-90deg)",
                    }}>
                    <CircularProgress
                        variant="determinate"
                        thickness={6}
                        style={{
                            color: 'rgba(234, 239, 241, 1)',
                        }}
                        size={sizeValue}
                        value={50}/>
                </Box>
                <Box
                    style={{
                        position: "absolute",
                        display: "inline-flex",
                        top: 0,
                        left: 0,
                        transform: "rotate(-90deg)",
                    }}>
                    <CircularProgress
                        variant="determinate"
                        thickness={6}
                        size={sizeValue}
                        value={scaledValue}/>
                </Box>

                <Typography
                    variant="caption"
                    style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        textAlign: 'center',
                        fontSize: (sizeUnit / 4) ,
                    }}>
                    {progressValue}%
                </Typography>

            </Box>
        )
    }

    return (
        <div style={{...progressStyles}}>
            <Box display="flex" alignItems="center">
                <Box width="100%" mr={1}>
                    <LinearProgress
                        variant="determinate"
                        value={Number(progressValue)}
                        classes={{root: classes.linearProgressRoot}}
                    />
                </Box>
                <Box minWidth={35}>
                    <Typography variant="body2" color="textSecondary">{`${Math.round(
                        Number(progressValue),
                    )}%`}</Typography>
                </Box>
            </Box>
        </div>

    )
};

ProgressComponent.propTypes = {
    component: PropTypes.shape({
        properties: PropTypes.shape({
            value: PropTypes.string,
            type: PropTypes.string,
            variant: PropTypes.string
        })
    })
};

export default JsonScreenHoc(ProgressComponent)

